import React from 'react';
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CButton
} from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData } from 'react-router-dom';
import axios from "axios";
import CIcon from '@coreui/icons-react'
import {
  cilPen,
  cilPlus,
  cilTrash
} from '@coreui/icons'
import { confirmAlert } from 'react-confirm-alert'; // Import
import { useState } from 'react';
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
import CustomPagination from 'src/components/pagination/CustomPaginatiion';

const tokenStr = localStorage.getItem('user');
const header = { headers: { "Authorization": `Bearer ${tokenStr}` } };



export async function LoaderLanguages({ params }) {
  let res = await axios.get(process.env.REACT_APP_SERVER_URL + '/api/languages', header).then((response) => {
    return response;
  });
  return res;
}

const Languages = ({ user_data }) => {
  if (!Permissions(user_data, 'Languages', 'VIEW_LANGUAGES')) {
    return <PermissionsNoPage />;
  }
  const { data } = useLoaderData();
  const [rows, setRows] = useState(false);
  const [rowCountState, setRowCountState] = React.useState(0);
  if (!rows) {
    setRowCountState(data['hydra:totalItems'])
    setRows(data['hydra:member']);
  }

  const getRowsTable = (p = 1) => {
    axios.get(process.env.REACT_APP_SERVER_URL + '/api/languages?page=' + p, header).then((response) => {
      console.log(response);
      setRows(response.data['hydra:member']);
    });
  };


  const handlePageChange = (page) => {
    getRowsTable(page + 1);
  }



  function Deleted(row) {
    confirmAlert({
      title: 'Ви впевнені що хочите видалити цей пункт ?',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            const response = axios.delete(process.env.REACT_APP_SERVER_URL + '/api/languages/' + row.id, header).then((response) => {
              getRowsTable();
            });
          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });

  }

  const columns = [
    {
      field: 'name', headerName: 'Назва',
      sortable: false,
      disableColumnMenu: true,
      width: 200
    },
    // { field: 'option_key', headerName: 'Ключ', width: 220 },
    {
      field: 'key', headerName: 'Ключ',
      sortable: false,
      disableColumnMenu: true,
      width: 220
    },
    {
      field: 'value',
      headerName: 'Значення',

      sortable: false,
      disableColumnMenu: true,
      width: 400
    },
    {
      field: "action",
      headerName: "Редагувати",
      sortable: false,
      width: 100,
      headerName: "",
      headerClassName: "hide-header",
      align: 'center',
      width: 70,

      // renderCell: (params) => {
      // return <Link to={'/languages/update/' + params.row.id}><CButton color="dark" variant="outline"><CIcon icon={cilPen} customClassName="nav-icon" height={20} /></CButton></Link>;
      // }
      renderCell: (params) => {
        return <Link to={'/languages/update/' + params.row.id}><img src="/edit.svg" alt="edit" /></Link>;
      }

    },
    {
      field: "delete",
      headerName: "Видалити",
      sortable: false,
      width: 100,
      headerName: "",
      headerClassName: "hide-header",
      align: 'center',
      width: 70,

      // renderCell: (params) => {
      //   return <CButton color="danger" variant="outline" onClick={() => {
      //     Deleted(params.row)
      //   }
      //   }><CIcon icon={cilTrash} customClassName="nav-icon" height={20} /></CButton>;
      // }
      renderCell: (params) => {
        return <button className='transparent' onClick={() => Deleted(params.row)}><img src="/delete.svg" alt="delete" /></button>
      }

    },
  ];
  return (
    <CRow>
      <CCol xs={12}>
        <CCard className="mb-4 mt-4">
          <CCardHeader
            className='items_card_header'
          >
            {/* <strong> */}
            Мови
            {/* </strong> */}
            <small
              className='items_card_header_small'
            >для перекладів</small>
          </CCardHeader>
          <CCardBody>
            <div className='head_items_wrapper_solo'>
              <p className="text-medium-emphasis small">
                <Link to="/languages/create" className='link_add_button'><CButton className='item_add_button' color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                  {/* Створити */}
                  Add
                </CButton></Link>
              </p>
            </div>
            <div style={{ height: 800, width: '100%' }}>

              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={30}
                rowsPerPageOptions={[30]}
                pagination
                rowCount={rowCountState}
                paginationMode="server"
                onPageChange={handlePageChange}

                components={{ Pagination: CustomPagination }}
                headerHeight={44}

                sx={{
                  borderRadius: '12px',
                  border: '1px solid #ccc',

                  '& .MuiDataGrid-main': {
                    // borderRadius: '12px',
                  },
                  '& .MuiDataGrid-columnHeaders': {
                    borderTopLeftRadius: '12px',
                    borderTopRightRadius: '12px',
                    fontFamily: 'Inter',
                    fontWeight: '600',
                    fontSize: '12px',
                    lineheight: '150%',
                    color: '#717680',
                    //   borderBottom: '2px solid #4e73df',

                  },
                  '& .MuiDataGrid-cell': {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '14px',
                    color: '#434349',
                  },
                  '& .MuiDataGrid-footerContainer': {
                    // borderBottomLeftRadius: '12px',
                    // borderBottomRightRadius: '12px',
                  },
                }}
              />
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );


}

export default Languages;